import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'nb',
  Pagination: {
    items_per_page: '/ side',
    jump_to: 'Gå til side',
    page: '',
    prev_page: 'Forrige side',
    next_page: 'Neste side',
    prev_5: '5 forrige',
    next_5: '5 neste',
    prev_3: '3 forrige',
    next_3: '3 neste',
  },
  DatePicker: {
    lang: {
      placeholder: 'Velg dato',
      yearPlaceholder: 'Velg år',
      quarterPlaceholder: 'Velg kvartal',
      monthPlaceholder: 'Velg måned',
      weekPlaceholder: 'Velg uke',
      rangePlaceholder: [
        'Startdato',
        'Sluttdato',
      ],
      rangeYearPlaceholder: [
        'Startår',
        'Sluttår',
      ],
      rangeMonthPlaceholder: [
        'Startmåned',
        'Sluttmåned',
      ],
      rangeWeekPlaceholder: [
        'Start uke',
        'Sluttuke',
      ],
      locale: 'nb_NO',
      today: 'I dag',
      now: 'Nå',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Annuller',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Velg tidspunkt',
      dateSelect: 'Velg dato',
      weekSelect: 'Velg uke',
      monthSelect: 'Velg måned',
      yearSelect: 'Velg år',
      decadeSelect: 'Velg tiår',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'DD',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned (PageUp)',
      nextMonth: 'Neste måned (PageDown)',
      previousYear: 'Forrige år (Control + venstre)',
      nextYear: 'Neste år (Control + høyre)',
      previousDecade: 'Forrige tiår',
      nextDecade: 'Neste tiår',
      previousCentury: 'Forrige århundre',
      nextCentury: 'Neste århundre',
    },
    timePickerLocale: {
      placeholder: 'Velg tid',
      rangePlaceholder: [
        'Starttid',
        'Sluttid',
      ],
    },
  },
  TimePicker: {
    placeholder: 'Velg tid',
    rangePlaceholder: [
      'Starttid',
      'Sluttid',
    ],
  },
  Calendar: {
    lang: {
      placeholder: 'Velg dato',
      yearPlaceholder: 'Velg år',
      quarterPlaceholder: 'Velg kvartal',
      monthPlaceholder: 'Velg måned',
      weekPlaceholder: 'Velg uke',
      rangePlaceholder: [
        'Startdato',
        'Sluttdato',
      ],
      rangeYearPlaceholder: [
        'Startår',
        'Sluttår',
      ],
      rangeMonthPlaceholder: [
        'Startmåned',
        'Sluttmåned',
      ],
      rangeWeekPlaceholder: [
        'Start uke',
        'Sluttuke',
      ],
      locale: 'nb_NO',
      today: 'I dag',
      now: 'Nå',
      backToToday: 'Gå til i dag',
      ok: 'Ok',
      clear: 'Annuller',
      month: 'Måned',
      year: 'År',
      timeSelect: 'Velg tidspunkt',
      dateSelect: 'Velg dato',
      weekSelect: 'Velg uke',
      monthSelect: 'Velg måned',
      yearSelect: 'Velg år',
      decadeSelect: 'Velg tiår',
      yearFormat: 'YYYY',
      dateFormat: 'DD.MM.YYYY',
      dayFormat: 'DD',
      dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Forrige måned (PageUp)',
      nextMonth: 'Neste måned (PageDown)',
      previousYear: 'Forrige år (Control + venstre)',
      nextYear: 'Neste år (Control + høyre)',
      previousDecade: 'Forrige tiår',
      nextDecade: 'Neste tiår',
      previousCentury: 'Forrige århundre',
      nextCentury: 'Neste århundre',
    },
    timePickerLocale: {
      placeholder: 'Velg tid',
      rangePlaceholder: [
        'Starttid',
        'Sluttid',
      ],
    },
  },
  global: {
    placeholder: 'Vennligst velg',
  },
  Table: {
    filterTitle: 'Filtermeny',
    filterConfirm: 'OK',
    filterReset: 'Nullstill',
    filterEmptyText: 'Ingen filtre',
    selectAll: 'Velg alle',
    selectInvert: 'Inverter gjeldende side',
    selectionAll: 'Velg all data',
    sortTitle: 'Sorter',
    expand: 'Utvid rad',
    collapse: 'Skjul rad',
    triggerDesc: 'Sorter data i synkende rekkefølge',
    triggerAsc: 'Sorterer data i stigende rekkefølge',
    cancelSort: 'Klikk for å avbryte sorteringen',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Avbryt',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Avbryt',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Søk her',
    itemUnit: 'element',
    itemsUnit: 'elementer',
    remove: 'Fjern',
    selectCurrent: 'Velg gjeldende side',
    removeCurrent: 'Fjern gjeldende side',
    selectAll: 'Velg all data',
    removeAll: 'Fjern all data',
    selectInvert: 'Inverter gjeldende side',
  },
  Upload: {
    uploading: 'Laster opp...',
    removeFile: 'Fjern fil',
    uploadError: 'Feil ved opplastning',
    previewFile: 'Forhåndsvisning',
    downloadFile: 'Last ned fil',
  },
  Empty: {
    description: 'Ingen data',
  },
  Icon: {
    icon: 'ikon',
  },
  Text: {
    edit: 'Rediger',
    copy: 'Kopier',
    copied: 'Kopiert',
    expand: 'Utvid',
  },
  PageHeader: {
    back: 'Tilbake',
  },
  Form: {
    defaultValidateMessages: {
      default: 'Feltvalideringsfeil ${label}',
      required: 'Vennligst skriv inn ${label}',
      enum: '${label} må være en av [${enum}]',
      whitespace: '${label} kan ikke være et blankt tegn',
      date: {
        format: '${label} datoformatet er ugyldig',
        parse: '${label} kan ikke konverteres til en dato',
        invalid: '${label} er en ugyldig dato',
      },
      types: {
        string: '${label} er ikke et gyldig ${type}',
        method: '${label} er ikke et gyldig ${type}',
        array: '${label} er ikke et gyldig ${type}',
        object: '${label} er ikke et gyldig ${type}',
        number: '${label} er ikke et gyldig ${type}',
        date: '${label} er ikke et gyldig ${type}',
        boolean: '${label} er ikke et gyldig ${type}',
        integer: '${label} er ikke et gyldig ${type}',
        float: '${label} er ikke et gyldig ${type}',
        regexp: '${label} er ikke et gyldig ${type}',
        email: '${label} er ikke et gyldig ${type}',
        url: '${label} er ikke et gyldig ${type}',
        hex: '${label} er ikke et gyldig ${type}',
      },
      string: {
        len: '${label} må være ${len} tegn',
        min: '${label} må minst ha ${min} tegn',
        max: '${label} opp til ${max} tegn',
        range: '${label} må være mellom ${min}-${max} tegn',
      },
      number: {
        len: '${label} må være lik ${len}',
        min: '${label} minimumsverdien er ${min}',
        max: '${label} maksimumsverdien er ${max}',
        range: '${label} må være mellom ${min}-${max}',
      },
      array: {
        len: 'Må være ${len} ${label}',
        min: 'Må være minst ${min} ${label}',
        max: 'På det meste ${max} ${label}',
        range: 'Totalt av ${label} må være mellom ${min}-${max}',
      },
      pattern: {
        mismatch: '${label} stemmer ikke overens med mønsteret ${pattern}',
      },
    },
  },
};

export default localeValues;
